<template>
    <form v-on:submit.prevent="login()">
        <div class="py-3">
            <h4 class="text-primary">Connexion</h4>
            <div class="alert alert-danger" role="alert" v-if="message">{{ message }}</div>
        </div>

        <div class="form-group">
            <select class="form-control" v-model="site">
                <option v-for="site in sites" :value="site" :key="site.name">{{ site.name }}</option>
            </select>
        </div>

        <div class="input-group form-group">
            <div class="input-group-prepend">
                <span class="input-group-text">@</span>
            </div>
            <input type="email" class="form-control" placeholder="identifiant" v-model="email" />
        </div>

        <div class="input-group form-group">
            <div class="input-group-prepend">
                <span class="input-group-text">*</span>
            </div>
            <input
                type="password"
                class="form-control"
                placeholder="mot de passe"
                v-model="password"
            />
        </div>

        <div class="text-right form-group">
            <button type="submit" class="btn btn-outline-primary">Me connecter</button>
        </div>
    </form>
</template>

<script>
export default {
    name: "LoginForm",
    data() {
        return {
            site: "",
            email: "",
            password: "",
            message: ""
        };
    },
    methods: {
        login(e) {
            this.message = "";
            console.log("site", this.site);
            let site_url;
            if (this.dev) site_url = this.site.url_dev;
            else site_url = this.site.url; // server has to be set to allow cors
            window.axios.defaults.baseURL = site_url;
            this.$store
                .dispatch("loginAction", {
                    email: this.email,
                    password: this.password
                })
                .then(() => {
                    localStorage.setItem("site_url", site_url);
                    localStorage.setItem("site_name", this.site.name);
                    localStorage.setItem("api", this.site.api);
                    localStorage.setItem("image_path", this.site.image_path);
                    localStorage.setItem("image_width", this.site.image_width);
                    localStorage.setItem(
                        "image_height",
                        this.site.image_height
                    );
                    this.$emit("success");
                })
                .catch(error => {
                    console.log(error);
                    this.message = error;
                });
        }
    }
};
</script>
